import { readSecureCardNumberText } from './readSecureCardNumberText';
const CARD_NUMBER_GROUP_SEPARATOR = /(\d{4})(?=\d)/g;
function stripCardNumberSpacing(text) {
    return text.replace(/\s+/g, '');
}
function isCardNumberDigitsOnly(text) {
    return /^\d+$/.test(text);
}
export function formatSecureCardNumberText(text) {
    const digits = stripCardNumberSpacing(text);
    if (!isCardNumberDigitsOnly(digits)) {
        return text.replace(/\s+/g, ' ').trim();
    }
    return digits.replace(CARD_NUMBER_GROUP_SEPARATOR, '$1 ');
}
export function toSecureCardNumberClipboardText(text) {
    const digits = stripCardNumberSpacing(text);
    return isCardNumberDigitsOnly(digits) ? digits : text;
}
export function formatSecureCardNumberElement(cardNumberElement) {
    if (!cardNumberElement) {
        return;
    }
    const formatted = formatSecureCardNumberText(readSecureCardNumberText(cardNumberElement));
    if (!formatted || formatted === cardNumberElement.textContent) {
        return;
    }
    cardNumberElement.textContent = formatted;
}
